import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';



export const compHistoryTableStyles = makeStyles((theme) => ({
    paginatedTable: {
        border: `1px solid ${tcsmColors.greySeven}`,
        boxShadow: '0px 1px 1px rgba(48, 48, 48, 0.3)',
        borderRadius: '3px',
        '& .paginated-table': {
            '&-row': {
                display: 'flex',
                '&:nth-child(even)': {
                    backgroundColor: tcsmColors.greySeven,
                },
                '&-cell': {
                    padding: theme.spacing(.75),
                    '&-header': {
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '40%',
                        borderRight: `1px solid ${tcsmColors.greyFive}`,
                        '&-mobile': {
                            display: 'flex',
                            justifyContent: 'space-between',
                        },
                    },

                    '&-value': {
                        width: '30%',
                        '&:nth-child(2)': {
                            borderRight: `1px solid ${tcsmColors.greyFive}`,
                        },
                    },
                },
                '&-mobile': {
                    display: 'block',
                    padding: theme.spacing(.75),
                },
                '& .row-tooltip': {
                    marginLeft: theme.spacing(.5),
                },

            },

            '&-edit': { // styling edit row
                '&-row': {
                    [theme.breakpoints.up('sm')]: {
                        display: 'flex',
                        
                    },
                   
                    '&:before': {
                        [theme.breakpoints.up('sm')]: {
                            display: 'block',
                            content: '""',
                            width: '40%',
                        },
                    },
                    '&-cell': {
                        [theme.breakpoints.up('sm')]: {
                            width: '30%',
                        },
                        '&:first-child': {
                            [theme.breakpoints.up('sm')]: {
                                borderLeft: `1px solid ${tcsmColors.greyFive}`,
                                borderRight: `1px solid ${tcsmColors.greyFive}`,
                            },
                        },
                    },
                },
            },
        },
        '& .pagination-inner': {
            borderTop: `1px solid ${tcsmColors.greyFive}`,
            padding: theme.spacing(.75),
        },
    },
    paymentTable: {
        border: `1px solid ${tcsmColors.greySeven}`,
        boxShadow: '0px 1px 1px rgba(48, 48, 48, 0.3)',

        '& .payment-table': {
            '&-row': {

                [theme.breakpoints.up('sm')]: {
                    display: 'flex',
                },
            },
            '&-cell': {
                padding: theme.spacing(1),
                width: 'calc(100% / 3)',
            },
        },
        '& .payment-table-content': {
            '& > .payment-table-row': {
                '&:nth-child(even)': {
                    backgroundColor: tcsmColors.greySeven,
                },
            },
        },
    },
}));



